var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoAxaBots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    width: 77,
    height: 53,
    viewBox: "0 0 77 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.318.375c14.355 0 25.992 11.637 25.992 25.992S65.673 52.359 51.318 52.359H25.992C11.637 52.359 0 40.722 0 26.367S11.637.375 25.992.375h25.326zm-.512 10.078H26.504c-8.789 0-15.914 7.125-15.914 15.914S17.715 42.28 26.504 42.28h1.031v5.835l7.413-5.835h15.858c8.79 0 15.914-7.124 15.914-15.913 0-8.79-7.125-15.914-15.914-15.914z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.655,
    cy: 26.912,
    r: 3.999
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.993,
    cy: 26.912,
    r: 3.999
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.317,
    cy: 26.912,
    r: 3.999
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAxaBots);
export default __webpack_public_path__ + "static/media/logoAXABots.b4e1d490b100d9e3e9e40d90eef2bff2.svg";
export { ForwardRef as ReactComponent };